import RecentFileCard from './RecentFileCard';
import { RecentFilesFRECallout } from './RecentFilesFRECallout';
import {
    getSharePointItemsViewIsAtRootLevel,
    getRecentFilesViewState,
} from 'owa-group-files-hub-store';
import { getCurrentGroupSmtpAddress, getGroupResource } from 'owa-groups-shared-store';
import { LightningId } from 'owa-lightning-v2';
import strings from 'owa-strings/owa-groups-strings';
import { Label } from 'office-ui-fabric-react/lib/components/Label';
import { observer } from 'mobx-react';
import * as React from 'react';

const classnames = require('classnames');
const styles = require('./RecentFiles.scss');

@observer
export class RecentFiles extends React.Component<{}, {}> {
    private recentsHeaderDiv: HTMLElement;
    render(): JSX.Element {
        const state = getRecentFilesViewState.get();
        const groupSiteUrlAvailable =
            getGroupResource(getCurrentGroupSmtpAddress(), 'Site') != null;

        if (!state || state.isLoading) {
            return null;
        }

        if (state.files.length == 0) {
            return null;
        }

        const totalNumberOfCards = state.files.length;

        return (
            <div className={this.getRecentFilesClassNames(state.smtpAddress)}>
                <div
                    className={styles.fileListHeader}
                    ref={ref => {
                        this.recentsHeaderDiv = ref;
                    }}>
                    <Label id="recentsheader" className={styles.fileListHeaderLabel}>
                        {strings.fileshubRecentPanelHeader}
                    </Label>
                </div>
                <RecentFilesFRECallout
                    lid={LightningId.GroupFilesHubFRE}
                    target={() => this.recentsHeaderDiv}
                />
                <div
                    className={styles.fileList}
                    tabIndex={0}
                    aria-labelledby="recentsheader"
                    role="group">
                    {state.files.map((item, index) => (
                        <div className={styles.fileListItem} data-is-focusable={true} key={item.id}>
                            <RecentFileCard
                                fileInformation={item}
                                cardIndex={index}
                                totalNumberOfCards={totalNumberOfCards}
                                groupSiteUrlAvailable={groupSiteUrlAvailable}
                            />
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    private getRecentFilesClassNames(groupSmtpAddress: string): string {
        const hideRecent = !getSharePointItemsViewIsAtRootLevel(groupSmtpAddress); // hide when not at root
        return classnames(styles.recentFilesContainer, { [styles.hidden]: hideRecent });
    }
}
